import React, { useContext, useEffect } from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import { Loader } from "@amzn/dolphin-uiweb-framework";
import { AppContext } from "./context/app-context.js";
import STRINGS from "./locale/strings.js";
import NavigationSupport from "./utils/navigation-support.js";

const ScanVinLanding = React.lazy(() =>
  import("./components/vin-scanning/scan-vin-landing.js")
);
const ScanVin = React.lazy(() =>
  import("./components/vin-scanning/scan-vin.js")
);
const ManualVinInput = React.lazy(() =>
  import("./components/vin-scanning/manual-vin-input.js")
);

const OperationalStatus = React.lazy(() =>
  import("./components/operational-status/operational-status.js")
);

const ViewIssues = React.lazy(() =>
  import("./components/view-issues/view-issues.js")
);

const CertifyRepairs = React.lazy(() =>
  import("./components/certify-repairs/certify-repairs.js")
);

const StartVSA = React.lazy(() =>
  import("./components/vehicle-safety-audit/start-vsa.js")
);

const MoveToLocation = React.lazy(() =>
  import(
    "./components/vehicle-safety-audit/move-to-location/move-to-location.js"
  )
);

const InspectionCategory = React.lazy(() =>
  import(
    "./components/vehicle-safety-audit/inspection-category/inspection-category.js"
  )
);

const AuditSummary = React.lazy(() =>
  import("./components/vehicle-safety-audit/audit-summary/audit-summary.js")
);

const TakePhoto = React.lazy(() =>
  import("./components/take-photo/take-photo.js")
);

export const ROUTE_PATH = {
  INDEX: { PATH: "/", TITLE: "vehicle_safety_audit" },
  SCAN_VIN_LANDING: {
    PATH: "/scan-vin-landing",
    TITLE: "vehicle_safety_audit",
  },
  SCAN_VIN: { PATH: "/scan-vin", TITLE: "vsa_scan_vin_title" },
  MANUAL_VIN_INPUT: {
    PATH: "/manual-vin-input",
    TITLE: "vsa_manual_vin_input_title",
  },
  OPERATIONAL_STATUS: {
    PATH: "/operational-status",
    TITLE: "vehicle_safety_audit",
  },
  VIEW_ISSUES: {
    PATH: "/view-issues",
    TITLE: "view_issues",
  },
  CERTIFY_REPAIRS: {
    PATH: "/certify-repairs",
    TITLE: "certify_repairs",
  },
  START_VSA: {
    PATH: "/start-vsa",
    TITLE: "vehicle_safety_audit",
  },
  MOVE_TO_LOCATION: {
    PATH: "/move-to-location",
    TITLE: "vehicle_safety_audit",
  },
  INSPECTION_CATEGORY: {
    PATH: "/inspection-category",
    TITLE: "vehicle_safety_audit",
  },
  AUDIT_SUMMARY: {
    PATH: "/audit-summary",
    TITLE: "audit_summary",
  },
  TAKE_PHOTO: {
    PATH: "/take-photo",
    TITLE: "take_photo_title",
  },
};

function Routing(props) {
  const { appState, formatMessage, appActions } = useContext(AppContext);

  useEffect(() => {
    //Update AppTopNavigation title on navigate
    Object.values(ROUTE_PATH).forEach((route) => {
      if (route.PATH === props.location.pathname) {
        appActions.updateTitle(formatMessage(route.TITLE));
      }
    });

    //Help options added here
    const manualVinInput = {
      title: formatMessage(STRINGS.unable_to_scan),
      onClick: () => {
        NavigationSupport.push(props, ROUTE_PATH.MANUAL_VIN_INPUT.PATH);
        appActions.closeHelp();
      },
    };

    /**
     * If location is ROUTE_PATH.SCAN_VIN.PATH adds the option to the HelpOptions list
     * Else other location, clears the list.
     */
    if (props.location.pathname === ROUTE_PATH.SCAN_VIN.PATH) {
      appActions.updateHelpOptionsList(
        manualVinInput,
        formatMessage(STRINGS.vsa_scan_vin_title)
      );
    } else appActions.clearHelpOptionsList();

    /**
     * Automatically removes alert and shows pending alert when location changes
     */
    if (
      props.location.pathname !== appState.alertOptions.destination &&
      appState.alertOptions.pending === false
    ) {
      appActions.hideAlert();
    } else {
      appActions.showPendingAlert();
    }
  }, [props.location]);

  return (
    <React.Suspense fallback={<Loader />}>
      <Switch>
        <Route path={ROUTE_PATH.TAKE_PHOTO.PATH} component={TakePhoto} />
        <Route path={ROUTE_PATH.AUDIT_SUMMARY.PATH} component={AuditSummary} />
        <Route
          path={ROUTE_PATH.INSPECTION_CATEGORY.PATH}
          component={InspectionCategory}
        />
        <Route
          path={ROUTE_PATH.MOVE_TO_LOCATION.PATH}
          component={MoveToLocation}
        />
        <Route path={ROUTE_PATH.START_VSA.PATH} component={StartVSA} />
        <Route
          path={ROUTE_PATH.CERTIFY_REPAIRS.PATH}
          component={CertifyRepairs}
        />
        <Route path={ROUTE_PATH.VIEW_ISSUES.PATH} component={ViewIssues} />
        <Route
          path={ROUTE_PATH.OPERATIONAL_STATUS.PATH}
          component={OperationalStatus}
        />
        <Route
          path={ROUTE_PATH.MANUAL_VIN_INPUT.PATH}
          component={ManualVinInput}
        />
        <Route path={ROUTE_PATH.SCAN_VIN.PATH} component={ScanVin} />
        <Route
          path={ROUTE_PATH.SCAN_VIN_LANDING.PATH}
          component={ScanVinLanding}
        />
        <Route exact path={ROUTE_PATH.INDEX.PATH} component={ScanVinLanding} />
      </Switch>
    </React.Suspense>
  );
}

export default withRouter(Routing);
